import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=7dd83ffd&scoped=true&lang=html&"
import script from "./commentItem.vue?vue&type=script&lang=js&"
export * from "./commentItem.vue?vue&type=script&lang=js&"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=7dd83ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd83ffd",
  null
  
)

export default component.exports